import React from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import decorate from '../../utils/decorate';
import injectPermissions from '../../utils/permissionsInject';
import { AdminPageContent } from './AdminPageContent';

class AdminPage extends React.Component {
    static propTypes = {
        permissions: ImmutablePropTypes.map
    };

    static defaultProps = {
        permissions: Map()
    };

    render() {
        const { permissions } = this.props;
        const RcClasses = {
            'not-permitted': !permissions.get('contingencies/tags-mgmnt')
        };

        return (
            <AdminPageContent rcClasses={RcClasses}/>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default decorate(
    connect(injectPermissions(mapStateToProps)),
    AdminPage
);
